import { classNames } from '@repo/ui/src/utils/classNames';
import buildImageSrc from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { MediaType } from '@repo/ui/src/types/image';
import Image from '@repo/ui/src/components/Image/New';

interface HeroLogoProps {
  hasVideo?: boolean;
  logoMaxHeight?: string;
  logoMaxWidth?: string;
  logos: Array<MediaType>;
}

const HeroLogos = ({ logos, logoMaxHeight, logoMaxWidth, hasVideo }: HeroLogoProps) => {
  const imgHeight = logoMaxHeight || hasVideo ? 400 : 200;
  return (
    <div>
      {logos.map((logo, idx) => {
        const imageUrl = buildImageSrc(logo, 800, 0, 0);
        return (
          <Image
            className={classNames(logoMaxWidth && 'tw-w-full')}
            src={imageUrl}
            alt={logo.name || ''}
            key={idx}
            width={800}
            height={imgHeight}
          />
        );
      })}
    </div>
  );
};

export default HeroLogos;
